module.exports = __webpack_public_path__ + "img/log_grey.250de338.svg";